import React from "react";
import TableData from "./TableData";
import TableHeader from "./TableHeader";
import './table.scss';

export const Table = ({
    theadData,
    tbodyData,
    className,
    tDataClassname,
    tHeaderClassname
}) => {
    const tableClasses = [
        `bsw-table`,
        `${className ? className : ''}`,
    ].join(' ');

    return (
        <table className={tableClasses}>
            <thead>
                <tr>
                    {theadData && theadData.map((h, index) => {
                        return <TableHeader key={index} item={h} className={tHeaderClassname} />;
                    })}
                </tr>
            </thead>
            <tbody>
                {tbodyData && tbodyData.map((item) => {
                    return <TableData key={item.id} data={item.items} tDataClassname={tDataClassname } />;
                })}
                
            </tbody>
        </table>
    );
};

